module.exports = __webpack_public_path__ + "img/Drafts.f48f1002.svg";